import { Injectable } from '@angular/core';
import { PortalSettingsService } from './portal-settings.service';
import { NgxCurrencyInputMode } from '@dintecom/ngx-currency';
import { v4 as uuidv4 } from 'uuid';
import sanitize from 'sanitize-filename';
import moment from 'moment';
import { ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { HiringService } from '../../pages/hiring/services/hiring.service';
import { timer } from 'rxjs';
import { ExcelQueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
export interface DatePickerFormat {
  dateInputFormat: string;
  containerClass: string;
  showTodayButton: boolean;
  showClearButton: boolean;
  clearPosition: string;
  showWeekNumbers: boolean;
  setViewMode: string;
  adaptivePosition?: boolean;
}

export interface FadeLabel {
  status: string;
  time: string;
}

export type SsnTitle = 'SSN' | 'SIN';
export type SsnMask = '999-99-9999' | '999-999-999';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  portalSettings: any;
  isLoggedOut = false;
  hiringService: HiringService;

  constructor(portalSettingsService: PortalSettingsService, hiringService: HiringService) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.hiringService = hiringService;
  }

  public getDeviceType() {
    const ua = navigator.userAgent;

    if (/(tablet|ipad|playbook|silk|Macintosh)|(android(?!.*mobi))/i.test(ua)) {
      return 'tablet';
    }
    if (/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
      return 'mobile';
    }
    return 'desktop';
  }

  public isMobileMode() {
    if (typeof window.orientation !== 'undefined') return true;
    let check = false;
    (a => {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor);
    return check;
  }

  public getDateFormat(): string {
    if (this.portalSettings.CountryDateCode.ConfigValue == 'AU' || this.portalSettings.CountryDateCode.ConfigValue == 'CAN') {
      return 'dd/MM/yyyy';
    } else {
      return 'MM/dd/yyyy';
    }
  }

  public formatDate(date: Date, day: string, month: string, year: string) {
    let dateFormat = '';

    if (this.portalSettings.CountryDateCode.ConfigValue == 'AU' || this.portalSettings.CountryDateCode.ConfigValue == 'CAN') {
      dateFormat = `${day}/${month}/${year}`;
    } else {
      dateFormat = `${month}/${day}/${year}`;
    }
    return moment(date).utc().format(dateFormat);
  }

  public getDefaultDatepickerOptions(monthPicker = false): DatePickerFormat {
    const format = this.getDateFormat();
    return {
      dateInputFormat: monthPicker ? 'MM/YYYY' : format.toUpperCase(),
      containerClass: 'theme-blue',
      showTodayButton: true,
      showClearButton: true,
      clearPosition: 'left',
      showWeekNumbers: false,
      setViewMode: monthPicker ? 'month' : 'day',
      adaptivePosition: false,
    };
  }

  public diffBetweenFromAndToDate(from: Date, to: Date) {
    if (isNaN(from.getTime()) || isNaN(to.getTime())) return -1;
    const timeDiff = to.getTime() - from.getTime();
    return timeDiff / (1000 * 3600 * 24);
  }

  public getTimeSpanInterval() {
    let intervalConfig = parseInt(this.portalSettings.TimeSpanInterval.ConfigValue);
    if (intervalConfig != 15 && intervalConfig != 30 && intervalConfig != 60) {
      intervalConfig = 0;
    }
    return intervalConfig;
  }

  public fadeLabel(status): FadeLabel {
    let hour = new Date().getHours();
    let APM = ' AM';
    let hourStr, minStr, secStr;
    hourStr = hour.toString();
    if (hour == 24) {
      hour = 0;
      APM = ' PM';
    }
    if (hour == 12) {
      APM = ' PM';
    }
    if (hour > 12) {
      hour = hour - 12;
      APM = ' PM';
    }
    if (hour < 10) {
      hourStr = '0' + hour.toString();
    }
    const min = new Date().getMinutes();
    minStr = min.toString();
    if (min < 10) {
      minStr = '0' + min.toString();
    }
    const sec = new Date().getSeconds();
    secStr = sec.toString();
    if (sec < 10) {
      secStr = '0' + sec.toString();
    }
    return { status: status ? 'success' : 'danger', time: hourStr + ':' + minStr + ':' + secStr + APM };
  }

  public formatAttachmentName(fileName: string): string {
    return sanitize(fileName);
  }

  public openModal() {
    document.getElementById('modal').style.display = 'block';
    document.getElementById('modal').style.left = (window.innerWidth - 200) / 2 + 'px';
    document.getElementById('modal').style.top = window.scrollY + window.outerHeight * 0.3 + 'px';
    document.getElementById('fade').style.display = 'block';
  }

  public closeModal() {
    document.getElementById('modal').style.display = 'none';
    document.getElementById('fade').style.display = 'none';
  }

  public getCurrencySymbol(PRCo: number) {
    const currencyFormatSymbols = this.portalSettings.CurrencyFormatPerPRCo.ConfigValue;
    let currencySymbol = '$';

    const currencyRegex = /^((\d:\W)((,\d:\W)*)$)?/gi;
    const regexMatch = currencyRegex.exec(currencyFormatSymbols);

    if (regexMatch != null && regexMatch[0] != null && regexMatch[0] != '' && PRCo != null) {
      currencyFormatSymbols.split(',').forEach((val: string) => {
        if (val != null && val != '') {
          const arrayEntry = val.split(':');
          if (arrayEntry.length == 2 && arrayEntry[1].length == 1) {
            const currencyObject = { PRCo: parseInt(arrayEntry[0]), Currency: arrayEntry[1] };
            if (PRCo && currencyObject.PRCo == PRCo) {
              currencySymbol = currencyObject.Currency;
            }
          }
        }
      });
    }

    return currencySymbol;
  }

  public rdlNameList() {
    return {
      BenefitWindowAuditOverride: 'BenefitWindowAuditReport.rdl',
      CrewTimecardReportName: 'HRIM_CrewTimecard.rdl',
      DRTOverrideRDL: 'HRIM_DailyTimeReport.rdl',
      DailyHuddleRDLOverRide: 'HRIM_HuddleDHCompliance.rdl',
      DailyHuddleTPRDLOverRide: 'HRIM_HuddleTPCompliance.rdl',
      DailyReportSSRSOverride: 'HRIM_DailyReport.rdl',
      JCDetailRDLOverride: 'JCDetail.rdl',
      JobApprovalReportOverride: 'HRIM_JobApproval.rdl',
      POPendingSSRSOverride: 'HRIM_PendingPurchaseOrder.rdl',
      JCDetailRDLOverrideNexGen: 'JobCostDetail.rdl',
      POSSRSOverride: 'HRIM_PurchaseOrder.rdl',
      RDLOverride: 'HRIM_ExpenseReport.rdl',
      ShippingLabelRDLOverride: 'HRIM_ShippingLabel.rdl',
      TimecardRptName: 'HRIM_Timecard.rdl',
      TotalCompRptName: 'HRTotalCompensation.rdl',
      TrainingRosterRDLOverride: 'HRIM_TrainingRoster.rdl',
      TimecardAuditOverride: 'HRIM_TimecardAudit.rdl',
      TrainingTranscriptRDLOverride: 'HRIM_TrainingTranscript.rdl',
      WorkCompleteRDL: 'HRIM_SMWorkCompleted.rdl',
      SMForm: 'HRIM_SMForm.rdl',
      TimeOffCalendarRDLOverride: 'TimeOffCalendar.rdl',
      '1': '1095CIndividual.rdl',
      '2': 'BenefitExport.rdl',
      '3': 'BenefitsGrid.rdl',
      '4': 'ChecklistExport.rdl',
      '5': 'HRIM_ADGetPaperConsent.rdl',
      '6': 'HRIM_ApplicantSummary.rdl',
      '7': 'HRIM_BulletinExport.rdl',
      '8': 'HRIM_Checklist.rdl',
      '10': 'HRIM_DailySchedulePrint.rdl',
      '11': 'HRIM_DailyTimecardPrint.rdl',
      '22': 'HRIM_I9.rdl',
      '12': 'HRIM_I9Page2.rdl',
      '13': 'HRIM_JobTemplate.rdl',
      '14': 'HRIM_OnBoarding.rdl',
      '15': 'HRIM_PerformanceGraph.rdl',
      '16': 'HRIM_PerformanceReview.rdl',
      '17': 'HRIM_PerformanceTabular.rdl',
      '18': 'HRIM_ReqSummary.rdl',
      '19': 'HRIM_SelfIdentify.rdl',
      '20': 'HRIM_TrainingExport.rdl',
      '21': 'HRIM_UnapprovedBenefitRequests.rdl',
      '23': 'HRIM_W4.rdl',
      '24': 'HRIM_W4es.rdl',
      '25': 'HRIM_W4Template.rdl',
      '28': 'HRIM_W4_2020.rdl',
      '30': 'HRIM_ApplicantExport.rdl',
      '31': 'HRIM_ApplicantActiveStatusSummary.rdl',
      '32': 'HRIM_ApplicantDemographics.rdl',
      '33': 'HRIM_ApplicantSourcing.rdl',
      '34': 'HRIM_ApplicantTimeToHire.rdl',
      '35': 'HRIM_SelfIdentify_2020.rdl',
      '36': 'HRIM_ApplicantOfferToHire.rdl',
      '37': '1095CIndividual2020.rdl',
      '38': 'HRIM_SelfIdentify_2023.rdl',
      '39': 'HRIM_I9Nov2023.rdl',
      '40': 'HRIM_I9SupA.rdl',
      '41': 'HRIM_I9SupB.rdl',
    };
  }

  public fileExtensionIsValid(fileName: string) {
    const startingIndex = fileName.lastIndexOf('.');
    let fileExtension = fileName.toLowerCase();
    if (startingIndex !== -1) {
      fileExtension = fileExtension.substring(startingIndex).toLowerCase().substring(1);
    }
    const fileTypes = [
      'pdf',
      'jpg',
      'jpeg',
      'png',
      'gif',
      'tiff',
      'tif',
      'bmp',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pps',
      'pptx',
      'ppsx',
      'sldx',
      'msg',
      'txt',
      'csv',
      'rtf',
      'odt',
      'ods',
      'odp',
    ];
    return fileTypes.includes(fileExtension.toLowerCase());
  }

  public base64ArrayBuffer(arrayBuffer: any) {
    let base64 = '';
    const encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

    const bytes = new Uint8Array(arrayBuffer);
    const byteLength = bytes.byteLength;
    const byteRemainder = byteLength % 3;
    const mainLength = byteLength - byteRemainder;

    let a, b, c, d;
    let chunk;

    // Main loop deals with bytes in chunks of 3
    for (let i = 0; i < mainLength; i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18; // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12; // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6; // 4032     = (2^6 - 1) << 6
      d = chunk & 63; // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d];
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength];

      a = (chunk & 252) >> 2; // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4; // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '==';
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1];

      a = (chunk & 64512) >> 10; // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4; // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2; // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '=';
    }

    return base64;
  }

  public xmlToJson(xml) {
    // Create the return object
    let obj: { [key: string]: any };
    obj = {};
    if (xml.nodeType == 1) {
      // element
      // do attributes
      if (xml.attributes.length > 0) {
        obj['attributes'] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          const attribute = xml.attributes.item(j);
          obj['attributes'][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType == 3) {
      // text
      obj = xml.nodeValue;
    }
    // do children
    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const nodeName = item.nodeName;
        if (typeof obj[nodeName] == 'undefined') {
          obj[nodeName] = this.xmlToJson(item);
        } else {
          if (typeof obj[nodeName].push == 'undefined') {
            const old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(this.xmlToJson(item));
        }
      }
    }
    return obj;
  }

  public hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : null;
  }

  public base64ToBlob(base64: string, contentType = ''): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  public createGuid(): string {
    return uuidv4();
  }

  public checkIsGuid(data) {
    const regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
    return regexGuid.test(data);
  }

  public getCookieValue(name: string): string | null {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=');
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }

  public deleteCookie(name: string): void {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  }

  public checkSafari() {
    const userAgent = navigator.userAgent;
    return /Safari\//.test(userAgent) && !/(Chrome\/|Android\s)/.test(userAgent);
  }

  public getDefaultCurrencyMaskOptions(precision: any, PRCo) {
    const currencySymbol = this.getCurrencySymbol(PRCo);
    return {
      align: 'left',
      allowNegative: true,
      prefix: currencySymbol,
      precision: precision,
      nullable: true,
      inputMode: NgxCurrencyInputMode.Natural,
    };
  }

  public validateEmail(email: string) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
    return re.test(email);
  }

  public noFilter(term: string, item: any): boolean {
    // Used with ng-select [searchFn] to disable automatic
    // dropdown filtering when keyword filtering is done on the backend.
    // There is no native configuration to disable dropdown filtering on ng-select.
    return true;
  }

  /**
   * Checks if the file size meets the given byte limit.
   *
   * @param file - file to check size of
   * @param byteLimit - default is 10 MB (10485760 bytes)
   * @returns True if the file size is less than or equal to the specified byte limit.
   */
  public meetsFileSizeLimit(file: File, byteLimit = 10485760): boolean {
    return file.size <= byteLimit;
  }

  public isPrivateMode(): boolean {
    const storageTestKey = 'sTest';
    try {
      window.sessionStorage.setItem(storageTestKey, 'test');
      window.sessionStorage.removeItem(storageTestKey);
      return false;
    } catch (e) {
      if (e.code == DOMException.QUOTA_EXCEEDED_ERR && window.sessionStorage.length == 0) {
        return true;
      } else {
        throw e;
      }
    }
  }

  public updateFileType(files: any) {
    files.forEach((val: any) => {
      if (/\.(jpe?g|png|gif|bmp|tif?f)$/i.test(val.Filename)) {
        val.Type = 'Photo';
      } else {
        val.Type = 'file';
      }
    });
    return files;
  }

  public isImage(filename: string) {
    if (/\.(jpe?g|png|gif|bmp|tif?f)$/i.test(filename))
      return true;
    return false;
  }

  public getBrowserLanguage(): string {
    return navigator.language !== 'undefined' ? navigator.language : 'en-US';
  }

  public fileIsNotViewable(fileName: string): boolean {
    const startingIndex = fileName.lastIndexOf('.');
    let fileExtension = fileName.toLowerCase();
    if (startingIndex !== -1) {
      fileExtension = fileExtension.substring(startingIndex).toLowerCase().substring(1);
    }
    const nonViewableFileTypes: string[] = [
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pps',
      'pptx',
      'ppsx',
      'sldx',
      'msg',
      'txt',
      'csv',
      'rtf',
      'odt',
      'ods',
      'odp',
    ];
    return nonViewableFileTypes.includes(fileExtension);
  }

  public humanReadableFileSize(bytes, si = false, dp = 1): string {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }

    const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
  }

  public isDefined(value: any) {
    return value !== undefined && value !== null;
  }

  public buildURL(host: string, path: string): string {
    const url: URL = new URL(host);
    url.pathname = path;
    return url.toString();
  }

  public isValidURL(url: string): boolean {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  }

  public getISODate(date: Date): string {
    return date.toISOString().split('T')[0];
  }

  public getDateOnly(date: Date): Date {
    if (!date || date.toString() == 'Invalid Date') {
      return null;
    }

    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  public convertStringToDate(dateString: string): Date {
    const dateParts = dateString.split('/');
    if (dateParts.length == 3) {
      const datePartsInt = dateParts.map(x => parseInt(x));
      if (this.portalSettings.CountryDateCode.ConfigValue != 'US') {
        return new Date(datePartsInt[2], datePartsInt[1] - 1, datePartsInt[0]); // dd/mm/yyyy
      } else {
        return new Date(datePartsInt[2], datePartsInt[0] - 1, datePartsInt[1]); // mm/dd/yyyy
      }
    }

    return null;
  }

  public convertDateToString(date: Date): string {
    if (!date || date.toString() == 'Invalid Date') {
      return null;
    }

    if (this.portalSettings.CountryDateCode.ConfigValue != 'US') {
      return (
        date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
      ); // dd/mm/yyyy
    } else {
      return (
        (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getDate().toString().padStart(2, '0') + '/' + date.getFullYear()
      ); // mm/dd/yyyy
    }
  }

  public truncateValue(value: number, decimalPlaces: number): number {
    if (value === undefined || decimalPlaces === undefined) {
      return 0;
    }
    const factor = Math.pow(10, decimalPlaces);
    return Math.trunc(value * factor) / factor;
  }

  public modalErrorHandling(error: unknown): void {
    if (error === ModalDismissReasons.ESC || error === 'cancel') {
      return;
    }
    throw error;
  }

  public stringToIntOrZero(value: string): number {
    if (value === undefined || value === null) {
      return 0;
    }
    const parsedValue = parseInt(value, 10);
    return isNaN(parsedValue) ? 0 : parsedValue;
  }

  public async setSsnTitle(country: string | number): Promise<SsnTitle> {
    let ssnTitle: SsnTitle = 'SSN';
    if (country !== null) {
      country = await this.setCountryCode(country);
      switch (country) {
        case 'CA':
          ssnTitle = 'SIN';
          break;
        default:
          ssnTitle = 'SSN';
          break;
      }
    }
    return ssnTitle;
  }

  public async setSsnMask(country: string | number): Promise<SsnMask> {
    let ssnMask: SsnMask = '999-99-9999';
    if (country !== null) {
      country = await this.setCountryCode(country);
      switch (country) {
        case 'CA':
          ssnMask = '999-999-999';
          break;
        default:
          ssnMask = '999-99-9999';
          break;
      }
    }
    return ssnMask;
  }

  /**
   * Formats a given string as either a Social Security Number (SSN) or Social Insurance Number (SIN).
   *
   * - For SSN: Formats as `XXX-XX-XXXX`.
   * - For SIN: Formats as `XXX-XXX-XXX`.
   *
   * If the input does not contain exactly 9 digits, the original value is returned.
   *
   * @param value - The input string to format.
   * @param type - The type of number to format as: `'SSN'` for Social Security Number or `'SIN'` for Social Insurance Number.
   * @returns The formatted SSN or SIN string, or the original value if the input is invalid.
   */
  public formatSsnOrSin(value: string | null | undefined, type: 'SSN' | 'SIN'): string {
    if (value === null || value === undefined) {
      return '';
    }
    const digits = value.replace(/\D/g, '');

    if (digits.length !== 9) {
      return value;
    }

    if (type === 'SSN') {
      return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
    } else if (type === 'SIN') {
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    return value;
  }

  public removeDashes(value: string): string {
    if (value === undefined || value === null) {
      return '';
    }
    return value.replace(/-/g, '');
  }

  private async setCountryCode(country: string | number): Promise<string> {
    if (country === 'All') {
      country = await this.hiringService.getCompanyCountry(this.portalSettings.OnboardingLogoCo.ConfigValue);
    } else if (typeof country === 'number') {
      country = await this.hiringService.getCompanyCountry(country);
    }
    return country;
  }

  public delayRouting(lastExecutionTime: number, delayMs: number, callback: () => void): void {
    const elapsed = Date.now() - lastExecutionTime;

    if (lastExecutionTime === 0 || elapsed >= delayMs) {
      callback();
    } else {
      const waitTime = delayMs - elapsed;
      timer(waitTime).subscribe(() => {
        callback();
      });
    }
  }

  public isEmptyObject(obj: unknown): boolean {
    return !obj || typeof obj !== 'object' || obj === null || Array.isArray(obj) || Object.keys(obj).length === 0;
  }

  public excelQueryCellInfo(args: ExcelQueryCellInfoEventArgs, dateFormat: string): void {
    // Convert non-string values to strings to prevent "value.indexOf is not a function" error
    if (args.value !== null && args.value !== undefined && typeof args.value !== 'string') {
      if (typeof args.value === 'boolean') {
        args.value = args.value ? 'Yes' : 'No';
      } else if (args.value instanceof Date) {
        // Format Date objects to string using the configured date format
        args.value = moment(args.value).format(dateFormat.toUpperCase());
      } else if (typeof args.value === 'object') {
        // Only blank out non-Date objects (e.g., nested objects, arrays)
        args.value = '';
      } else {
        args.value = String(args.value);
      }
    }
  }
}
